import React, { Component } from 'react';
import { CheckCircle2, Voicemail, PhoneOff, UserX, Phone } from 'lucide-react';
import { CallOutcome } from './types';
const map: Record<CallOutcome, {
  icon: ComponentType<{
    className?: string;
  }>;
  classes: string;
  label: string;
}> = {
  Connected: {
    icon: CheckCircle2,
    classes: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
    label: 'Connected'
  },
  'Left Voicemail': {
    icon: Voicemail,
    classes: 'bg-blue-500/15 text-blue-300 border-blue-500/30',
    label: 'VM Left'
  },
  'No Answer': {
    icon: PhoneOff,
    classes: 'bg-orange-500/15 text-orange-300 border-orange-500/30',
    label: 'No Answer'
  },
  'Bad Number': {
    icon: UserX,
    classes: 'bg-red-500/15 text-red-300 border-red-500/30',
    label: 'Bad Number'
  }
};
export function CallOutcomeBadge({
  outcome,
  when
}: {
  outcome: CallOutcome | null | undefined;
  when?: string;
}) {
  if (!outcome) {
    return <span className="flex items-center gap-1 px-2 py-1 rounded text-[10px] font-bold uppercase tracking-wider border bg-slate-800 text-slate-400 border-slate-700" data-id="element-75">
        <Phone className="w-3 h-3" data-id="element-76" /> Never Contacted
      </span>;
  }
  const m = map[outcome];
  const Icon = m.icon;
  return <span className={`flex items-center gap-1 px-2 py-1 rounded text-[10px] font-bold uppercase tracking-wider border ${m.classes}`} title={when ? `Last call: ${new Date(when).toLocaleString()}` : undefined} data-id="element-77">
      <Icon className="w-3 h-3" data-id="element-78" /> {m.label}
      {when && <span className="ml-1 opacity-70 normal-case font-medium" data-id="element-79">
          · {formatRelative(when)}
        </span>}
    </span>;
}
function formatRelative(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / (1000 * 60));
  if (mins < 60) return `${Math.max(1, mins)}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}